export default __webpack_public_path__ + "static/media/BIPL.2a105bb4.png";